import React from 'react';
import { RecommendationsLayout } from '@beef/smart-kit';

import RecommendationDevice from 'components/Recommendations/components/RecommendationDevice';

type RecommendationsProps = {
  label?: string;
  isLoading?: boolean;
  categories?: any[];
  onChangeTab: (slug: string) => void;
  tabVariant?: string;
  skeletonItemsCount?: number;
  captionSize?: string;
  onAddToBasket: (id: number) => void;
  devices: any[];
  strategyName: string;
  strategyMessage: string;
  placement: string;
};

export const Recommendations = ({
  label,
  devices,
  onAddToBasket,
  isLoading,
  categories,
  onChangeTab,
  tabVariant = 'secondary',
  skeletonItemsCount = 4,
  captionSize = 'size3-m',
  strategyName,
  strategyMessage,
  placement,
}: RecommendationsProps) => (
  <div
    id="any-recs-container"
    // eslint-disable-next-line react/no-unknown-property
    strategyMessage={strategyMessage}
    // eslint-disable-next-line react/no-unknown-property
    placement={placement}
    // eslint-disable-next-line react/no-unknown-property
    strategyName={strategyName}
  >
    <RecommendationsLayout
      captionSize={captionSize}
      label={label}
      tabs={categories}
      tabVariant={tabVariant}
      onChangeTab={onChangeTab}
      skeletonItemsCount={skeletonItemsCount}
      devicesStatus={isLoading ? 'loading' : 'succeeded'}
      tabsStatus={isLoading ? 'loading' : 'succeeded'}
    >
      {devices.map((device) => (
        // eslint-disable-next-line react/no-unknown-property
        <div className="any-recs-product" product-id={device.id} key={device.id}>
          <RecommendationDevice device={device} onAddToBasket={onAddToBasket} />
        </div>
      ))}
    </RecommendationsLayout>
  </div>
);
